
var id = "dataIcon";
var markup = "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dataIcon\">\n<path d=\"M2 6V3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V6\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M10.6666 8V10.3333\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M8 5V10.3333\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M5.33337 6.33398V10.334\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M2 10V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V10\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
